module.exports = __webpack_public_path__ + "static/media/quicksign_.1085ef07.png";